import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { BranchesTable } from "@/services/backend/company/components/branches-table";
import { TableCard } from "@/shared/components/tables/table-card";
import { CreateBranchDialog } from "@/services/backend/company/components/create-branch-dialog";
import { NavLink, Outlet, useNavigate } from "react-router";
import { ReactNode, useCallback } from "react";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";

export function BranchesRoute() {
  const canAccess = useFeatureAuth("gsm.branches.write");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}

export function BranchesIndex() {
  const navigate = useNavigate();

  const renderRowLink = useCallback(
    (branchId: string, children: ReactNode) => (
      <NavLink to={`/base-data/branches/${branchId}`}>{children}</NavLink>
    ),
    [],
  );

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Niederlassungen")}</BaseDataPageTitle>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <div className="grid gap-2">
          <div className="ml-auto">
            <CreateBranchDialog
              onCreated={(id) => navigate(`/base-data/branches/${id}`)}
            />
          </div>
          <TableCard>
            <BranchesTable renderRowLink={renderRowLink} />
          </TableCard>
        </div>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
